var indexOf = [].indexOf;

angular.module('app.controllers').controller('ProgramsCtrl', ['$scope', '$rootScope', 'APIPrograms', 'Table', '$interval', 'APIForm', 'APIPolls', '$location', '$timeout', 'APIInquiries', 'UI', '$q'].append(function(self, root, APIPrograms, Table, $interval, APIForm, APIPolls, $location, $timeout, APIInquiries, UI, $q) {
  var ad, getLiveProgram, loadDayPrograms, programsInterval, td;
  self.currentProgram = null;
  getLiveProgram = function(initYT = false, customTime = '', rework = false) {
    var baseDate, currentTime, newCurrentProgram, ref, ref1;
    if (!((ref = self.programs) != null ? ref.length : void 0)) {
      return;
    }
    // Get custom time from URL if provided
    if ($location.search().test) {
      customTime = moment().format('HH:mm');
    } else {
      if ($location.search().time && !customTime) {
        customTime = $location.search().time;
      }
    }
    currentTime = moment();
    baseDate = '2026-06-16';
    if (customTime) {
      
      // If custom time provided, use it with the base date
      currentTime = moment(`${baseDate} ${customTime}`);
    }
    newCurrentProgram = self.programs.find(function(program) {
      var programDateEnd, programDateStart;
      programDateStart = program.dd.concat(` ${program.start}`);
      if (program.id === 6199) {
        programDateStart = program.dd.concat(" 08:00:00");
      }
      programDateEnd = program.dd.concat(` ${program.end}`);
      return currentTime.isBetween(programDateStart, programDateEnd, void 0, '[)');
    }) || null;
    if (newCurrentProgram !== self.currentProgram) {
      self.currentProgram = newCurrentProgram;
    }
    if (self.at('home')) {
      return root.$broadcast('toggleHomeIntro', ((ref1 = self.currentProgram) != null ? ref1.description_de : void 0) || null);
    }
  };
  programsInterval = $interval(getLiveProgram, 10000, 0, true, false, '', false);
  self.isOffline = function(slot) {
    var ref;
    return slot.id !== ((ref = self.currentProgram) != null ? ref.id : void 0);
  };
  ad = ['1', '16.06.2026'];
  td = moment().format('DD.MM.YYYY');
  if (self.at('home')) {
    self.day = 1;
  } else {
    self.day = indexOf.call(ad, td) >= 0 ? ad.indexOf(td) : 1;
  }
  self.setDay = function(day) {
    return self.day = day;
  };
  self.$watch('day', function(newObj, oldObj) {
    var ref;
    if (!newObj) {
      return;
    }
    if (((ref = self.programs) != null ? ref.length : void 0) && self.at('home')) {
      return;
    }
    return loadDayPrograms(newObj);
  }, true);
  self.days = [
    {
      title: '16.06',
      title_sm: '.26',
      day: 1,
      full: '2026-06-16'
    }
  ];
  loadDayPrograms = function(day, add = false) {
    self.dataLoad = false;
    return APIPrograms.get({
      day: day,
      _entry: 'programs'
    }, function(data) {
      var programs;
      programs = data.tracks.filter(function(track) {
        return track.visible;
      }).map(function(track) {
        track.slots = track.slots.filter(function(slot) {
          var ref;
          if (self.at('home')) {
            return slot.visible && ((ref = slot.slot_type) !== 'pause' && ref !== 'faq');
          }
          return slot.visible;
        }).map(function(slot) {
          slot.day_int = day;
          return slot;
        });
        return track;
      })[self.at('home') && data.tracks.length > 1 ? 1 : 0].slots;
      if (add) {
        self.programs = self.programs.concat(programs);
      } else {
        self.programs = programs;
      }
      if (self.at('home-') && day < self.days.length) {
        day++;
        loadDayPrograms(day, true);
      } else {
        getLiveProgram();
        self.dataLoad = true;
      }
      return self.$applyAsync();
    });
  };
  self.openProgramModal = function(data = null, id = null) {
    return root.$broadcast('onProgramModalOpen', data, id);
  };
  self.openSpeakerModal = function(data = null, id = null) {
    return root.$broadcast('onSpeakerModalOpen', data, id);
  };
  self.v23El = document.getElementById('videoModal23');
  if (self.v23El != null) {
    self.v23 = bootstrap.Modal.getOrCreateInstance(self.v23El);
    self.v23El.addEventListener('show.bs.modal', function(event) {
      var ref, ref1;
      self.customStat(null, 'open_23_link', ((ref = self.open23data) != null ? ref.title_de : void 0) || ((ref1 = self.open23data) != null ? ref1.title_en : void 0) || '');
      return self.$applyAsync();
    });
    self.v23El.addEventListener('hide.bs.modal', function(event) {
      var ref, ref1;
      self.closeDataModal();
      return self.customStat(null, 'close_23_link', ((ref = self.open23data) != null ? ref.title_de : void 0) || ((ref1 = self.open23data) != null ? ref1.title_en : void 0) || '');
    });
  }
  self.open23 = function(slot) {
    if (!(slot != null ? slot.description_de : void 0)) {
      return;
    }
    self.open23data = slot;
    self.v23.show();
    return self.showDataModal({
      video: slot.description_de,
      fair: null,
      variab: 'modalData23'
    });
  };
  self.$on('$destroy', function() {
    var playingInterval, pollsInterval;
    if (angular.isDefined(playingInterval)) {
      $interval.cancel(playingInterval);
      playingInterval = void 0;
    }
    if (angular.isDefined(pollsInterval)) {
      $interval.cancel(pollsInterval);
      pollsInterval = void 0;
    }
    if (angular.isDefined(programsInterval)) {
      $interval.cancel(programsInterval);
      return programsInterval = void 0;
    }
  });
  return self.default3colsSlider2 = {
    infinite: false,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    useCSS: false,
    cssEase: 'linear',
    dots: true,
    dotsClass: 'slider-dots',
    method: {},
    event: {
      init: function(event, slick) {
        return slick.slickFilter('[pr-day="1"]');
      }
    },
    customPaging: function(slider, i) {
      if (slider.slideCount === 1 || slider.slideCount === slider.options.slidesToShow) {
        return false;
      }
      return "<a class='slider-dots-item'></a>";
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '40px',
          infinite: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '24px',
          infinite: true
        }
      }
    ]
  };
}));

angular.module('app.controllers').controller('ProgramsModalCtrl', ['$scope', '$rootScope', 'APISlots', 'UI'].append(function(self, root, APISlots, UI) {
  self.id = null;
  self.data = null;
  self.programModalEl = document.getElementById('programModal');
  if (self.programModalEl) {
    self.programModal = bootstrap.Modal.getOrCreateInstance(self.programModalEl);
    self.programModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.id = null;
      self.data = null;
      return self.$applyAsync();
    });
    self.programModalEl.addEventListener('show.bs.modal', function(event) {
      if (!self.data) {
        APISlots.get({
          id: self.id,
          _entry: 'slot'
        }, function(data) {
          return self.data = data;
        }, function(response) {
          return UI.notify(false, response.data.error);
        });
      }
      return self.$applyAsync();
    });
  }
  self.$on('onProgramModalOpen', function(event, data = null, id = null) {
    self.id = id;
    self.data = data;
    return self.programModal.show();
  });
  return self.openSpeakerModal = function(data = null, id = null) {
    return root.$broadcast('onSpeakerModalOpen', data, id, false);
  };
}));
